module.exports = __webpack_public_path__ + "img/05.4e478778.png";